import ExcelJS from "exceljs";

const INVALID_SHEET_NAME_CHARS = /[:\\/?*[\]]/g;
const MAX_SHEET_NAME_LENGTH = 31;

export const sanitizeSheetName = (name, fallback = "Sheet") => {
    const cleaned = (name ?? "").replace(INVALID_SHEET_NAME_CHARS, "").trim().slice(0, MAX_SHEET_NAME_LENGTH);
    return cleaned.length > 0 ? cleaned : fallback;
};

export const uniqueSheetName = (usedNames, desiredName) => {
    if (!usedNames.has(desiredName)) return desiredName;

    let suffix = 2;
    let candidate;
    do {
        const suffixText = ` (${suffix})`;
        candidate = desiredName.slice(0, MAX_SHEET_NAME_LENGTH - suffixText.length) + suffixText;
        suffix++;
    } while (usedNames.has(candidate));

    return candidate;
};

export const buildWorkbook = (sheets) => {
    const workbook = new ExcelJS.Workbook();
    const usedNames = new Set();

    sheets.forEach(({ name, columns, rows }) => {
        const sheetName = uniqueSheetName(usedNames, sanitizeSheetName(name));
        usedNames.add(sheetName);

        const worksheet = workbook.addWorksheet(sheetName);
        worksheet.columns = columns.map(column => ({ header: column.header, key: column.key, width: column.width ?? 14 }));
        worksheet.addRows(rows);
    });

    return workbook;
};

export const downloadWorkbook = async (filename, sheets) => {
    const workbook = buildWorkbook(sheets);
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
};
